import { CompInfraestrutura } from "./CompInfraestrutura";

export default CompInfraestrutura;